<!--
 * @Description:
 * @Author: YY
 * @LastEditors: YY
 * @LastEditTime: 2023-12-21 10:18:55
-->
<template>
  <div class="driver-message">
    <el-dialog
      title="批量新增返优惠账户"
      :visible.sync="isVisible"
      :append-to-body="true"
      width="500px">
      <div>
        <div class="import-div">
          <p class="import-title title1">说明</p>
          <p>1.下载导入模版</p>
          <p>2.按照模板的说明维护导入表格内容</p>
          <p>3.上传表格</p>
          <p>4.点击确定之后则导入上传成功的表格内容</p>
          <p class="import-title">导入模板</p>
          <p>
            返优惠账户新增导入模板.xls
            <el-button type="primary" @click="downloadHandle">下载</el-button>
            <!-- <a target="_blank" href="https://jingbo-test.oss-cn-beijing.aliyuncs.com/%E8%B0%83%E6%8B%A8%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E6%A8%A1%E6%9D%BF%E6%96%87%E4%BB%B6.xlsx">下载</a> -->
          </p>
        </div>
        <div class="import-div">
          <p class="import-title">上传导入文件</p>
          <oss-upload v-model="accessory"
                      :accept="acceptExtArr"
                      :size="2"
                      :limit="1" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="finishDialog(0)">取 消</el-button>
        <el-button type="primary" @click="importHandle" :loading="importLoading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="导入结果"
      :visible.sync="dialogResult"
      :append-to-body="true"
      width="600px">
      <div class="import-div">
        <p class="import-result">导入{{importResult.importStatus == 1 ? '成功':'失败'}}，请下载表格查看导入结果。</p>
        <el-button type="primary" @click="downloadResult">下载导入结果</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="finishDialog(1)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import OssUpload from '@/components/ossUpload'

export default {
  name: 'customerDialog',
  components: { OssUpload },
  props: {
    info: Object
  },
  data () {
    return {
      dialogVisible: false,
      accessory: [],
      acceptExtArr: ['xls', 'xlsx'],
      dialogResult: false,
      importResult: {},
      importLoading: false
    }
  },
  computed: {
    isVisible () {
      return this.dialogVisible && !this.dialogResult
    }
  },
  mounted () {
    this.dialogVisible = true
  },
  methods: {
    ...mapActions(['exportAccountTemplate', 'importExcelAccount']),
    downloadHandle () {
      this.exportAccountTemplate().then(res => {
        this.createDownloadFile(res, '返优惠账户新增导入模板.xls')
      })
    },
    createDownloadFile (file, title) {
      let blobObject = new Blob([file])
      let fileName = title
      // 兼容 IE系列 浏览器
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobObject, fileName)
      } else {
        let link = document.createElement('a')
        link.download = fileName
        link.style.display = 'none'
        link.target = '_Blank'
        link.href = window.URL.createObjectURL(blobObject)
        console.log(link)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      }
    },
    importHandle () {
      this.importLoading = true
      const obj = this.accessory[0] || {}
      let params = {
        excelUrl: obj.url
      }
      this.importExcelAccount(params).then(res => {
        this.importLoading = false
        if (res.success) {
          this.dialogResult = true
          this.importResult = res.data
        }
      })
    },
    // type: 0代表取消 1代表确定选定
    finishDialog (type) {
      if (type === 1) {
      }
      this.dialogVisible = false
      this.$emit('update:visibleCustomerMessage', { visibleCustomer: false, customerDtos: this.importResult.dtos || [], type })
    },
    downloadResult () {
      window.open(this.importResult.resultExcelUrl)
    }
  },
  watch: {
    dialogVisible (newVal, oldVal) {
      console.log('[ newVal ] >', newVal)
      // if (newVal === false) {
      //   this.$emit('update:visibleGoodsMessage', { visibleGoodsMessage: false, selectData: [] })
      // }
    }
  }
}
</script>

  <style lang="scss" scoped>
  /deep/ .el-dialog__headerbtn{
    display: none;
  }
  .driver-message-container {
    margin-bottom: 10px;
    .container-options {
      display: flex;
      justify-content: space-between;
      .el-input__icon.el-icon-search:hover {
        cursor: pointer;
      }
    }
    .container-table {
      margin-top: 20px;
    }
  }
  .driver-message {
    /deep/ .el-dialog {
      width: 500px;
      /deep/ .el-dialog__body {
        padding-bottom: 0px;
      }
    }
  }
  .import-div{
    margin-bottom: 8px;
    a{
      color: #409eff;
    }
    .import-title{
      font-weight: bold;
      margin: 22px 0 5px 0;
      &.title1{
        margin-top: 0;
      }
    }
    .import-result{
      margin-bottom: 12px;
    }
  }
</style>
